import { BoxButton, Text } from '@bucketplace/design-system';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import { OHS_HOST } from '@/common/url';

export function PersonalizedStoreItemFallback() {
  const router = useRouter();

  return (
    <div
      css={css`
        padding: 0 16px;
      `}
    >
      <Container>
        <Text variant="body16L24" color="foregroundWeak" as="p">
          로그인하면 추천 상품을 볼 수 있어요
        </Text>

        <ButtonWrapper
          variant="brand-solid"
          size="small"
          onClick={() => {
            const path = `/events${router.asPath}`;
            const signInUrl = `${OHS_HOST}/users/sign_in?redirect_to=${encodeURIComponent(path)}`;
            window.location.href = signInUrl;
          }}
        >
          <BoxButton.Slot side="center">
            <BoxButton.Label>로그인하기</BoxButton.Label>
          </BoxButton.Slot>
        </ButtonWrapper>
      </Container>
    </div>
  );
}

const Container = styled.div`
  padding: 24px 16px;
  text-align: center;
  background-color: ${({ theme }) => theme.colors.backgroundWeak};
  border-radius: 8px;
`;

const ButtonWrapper = styled(BoxButton)`
  margin-top: 16px;
`;
